<div *lohiFeatureFlag="'migrationMapOwnerDashboard'; else originalDashboard" class="flex flex-col">
  <ng-container *lohiIsNotOnlyFiveFTourOwner>
    <div class="flex items-center" *lohiFeatureFlag="'migrationMapNavBar'">
      <ng-container *ngIf="bannerLoadsCount$ | async as loadsCount">
        <a
          style="background-image: url(assets/images/super-highway-banner.png)"
          class="flex w-full md:flex-row flex-col justify-between m-2 md:my-4 lg:mx-3 lg:mt-3 bg-cover cursor-pointer"
          [routerLink]="['/superhighway']"
          *lohiRelationship="'carrier'"
        >
          <div class="flex flex-row md:my-3 items-center">
            <img class="h-12 w-12 md:ml-6 m-1 md:mr-4" src="assets/images/super-highway-logo.png" />
            <div class="md:text-xl font-semibold md:px-4 md:px-6 p-1 items-center md:items-start md:mr-4 flex flex-col">
              <span class="text-blue-400 mb-1 text-center md:text-left"
                >{{ loadsCount }} Short-haul Loads Completed by SuperDrivers so Far</span
              >
              <span class="text-white text-center md:text-left leading-normal"
                >Register your drivers as 5F SuperDrivers to keep rolling on slow days! Haul Grain, Cement, Chemicals,
                and other payloads in addition to Sand.</span
              >
            </div>
          </div>
          <div
            class="flex flex-col items-center justify-center pl-5 pr-3 gap-y-2 md:flex hidden"
            style="background-color: #08a9e9; clip-path: polygon(23% 0, 100% 0, 100% 100%, 0 100%)"
          >
            <span class="text-2xl text-white font-bold w-25 text-center">Register Now</span>
          </div>
          <div
            class="flex flex-col items-center justify-center px-2 py-2 gap-y-2 block md:hidden"
            style="background-color: #08a9e9"
          >
            <span class="text-2xl text-white font-bold w-25 text-center">Register Now</span>
          </div>
        </a>
      </ng-container>
    </div>
  </ng-container>
  <div class="flex flex-col md:flex-row p-1 lg:px-3 md:grid md:grid-cols-4 md:gap-x-4">
    <div
      class="flex flex-col flex-1 mt-1 md:col-span-3"
      [class.md:col-span-4]="(userInfo$ | async)?.isCompanyFiveFTourOnly"
    >
      <div class="card-with-shadow flex flex-col bg-white rounded mb-6 h-35 md:h-75">
        <div class="flex items-center">
          <mat-form-field (click)="setupDrivers()" class="w-full px-3">
            <mat-select placeholder="Search Drivers, Trucks, or Trailers">
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Find Driver"
                  noEntriesFoundLabel="No Matching Drivers Found"
                  [formControl]="searchForm"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-optgroup *ngFor="let driverGroup of groupedDrivers$ | async; trackBy: 'name' | trackByKey">
                <div *ngIf="driverGroup.name === 'On Load'" class="flex items-center">
                  <div class="w-1 h-1 bg-blue-500 rounded-full mr-2"></div>
                  {{ driverGroup.name }}
                </div>
                <div *ngIf="driverGroup.name === 'On Shift'" class="flex items-center">
                  <div class="w-1 h-1 bg-black rounded-full mr-2"></div>
                  {{ driverGroup.name }}
                </div>
                <div *ngIf="driverGroup.name === 'Off Shift'" class="flex items-center">
                  <div class="w-1 h-1 bg-gray-600 rounded-full mr-2"></div>
                  {{ driverGroup.name }}
                </div>
                <mat-option
                  *ngFor="let driver of driverGroup.data; trackBy: 'id' | trackByKey"
                  (click)="navToDriver(driver)"
                  (onSelectionChange)="navToDriver(driver)"
                  style="min-height: 50px; line-height: 25px"
                >
                  <div *ngIf="driver.truckName && driver.trailerName">
                    {{ driver.name + ' - ' + ' Truck ' + driver.truckName + ' - ' + ' Trailer ' + driver.trailerName }}
                  </div>
                  <div *ngIf="driver.truckName && !driver.trailerName">
                    {{ driver.name + ' - ' + ' Truck ' + driver.truckName }}
                  </div>
                  <div *ngIf="!driver.truckName && driver.trailerName">
                    {{ driver.name + ' - ' + ' Trailer ' + driver.trailerName }}
                  </div>
                  <div *ngIf="!driver.truckName && !driver.trailerName">
                    {{ driver.name }}
                  </div>
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>
        <lohi-migration-map
          *lohiFeatureFlag="'migrationMap'"
          class="flex-1"
          [targets]="targets$ | async"
          [drivers]="searchableDriverList$ | async"
          [hazards]="hazards$ | async"
          (targetClicked)="targetClickedReceiver($event)"
          (mapClicked)="mapClickedReceiver()"
          [tourOnly]="(userInfo$ | async)?.isCompanyFiveFTourOnly"
        ></lohi-migration-map>
      </div>
    </div>
    <ng-container *lohiIsNotOnlyFiveFTourOwner>
      <div class="flex flex-col md:mt-1" *lohiFeatureFlag="'migrationMapInbox'" [ngSwitch]="targetSection">
        <div class="card-with-shadow bg-white flex flex-col h-75" *ngSwitchCase="'listOfTargets'">
          <div *ngIf="loadsNeedingAcceptance.length" class="border-b border-gray-300 pb-2 mb-2 m-1">
            <div class="text-gray-900 text-lg font-bold pt-2 mb-1 px-2 uppercase tracking-wide">
              Loads Needing Acceptance
            </div>
            <button
              type="button"
              *ngFor="let load of loadsNeedingAcceptance; trackBy: trackByLoadId"
              class="w-full text-left py-2 px-2 cursor-pointer rounded-md hover:bg-lightBlue2 border-0 bg-transparent border-l-4 border-l-orange-500 flex items-start justify-between gap-2"
              (click)="openLoadApprovalDialog(load)"
              matTooltip="Review and approve or reject"
            >
              <div class="min-w-0 flex-1">
                <div class="font-semibold text-black">{{ load.uniqueId }}</div>
                <div class="text-sm text-red-500 font-medium">
                  {{ load.driverName }} - {{ load.originSiteName }} to {{ load.destinationSiteName }}
                </div>
              </div>
              <mat-icon class="text-orange-500 flex-shrink-0" aria-hidden="true">chevron_right</mat-icon>
            </button>
          </div>
          <mat-tab-group mat-stretch-tabs class="flex-1 min-h-0 overflow-y-scroll m-1">
            <mat-tab label="Available">
              <div *ngIf="targets$ | async as targets" class="h-full">
                <ng-container *ngIf="targets.length > 0; else noInbox">
                  <div class="h-full flex flex-col justify-between p-2">
                    <div class="flex flex-col md:text-lg space-y-2 pb-1 mb-1">
                      <div class="flex justify-center">
                        <div *ngIf="targets.length > 1" class="py-1">
                          <span class="rounded-full bg-black text-white px-2 py-1 text-sm shadow-lg"
                            >{{ targets.length | number }} Available Opportunities</span
                          >
                        </div>
                        <div *ngIf="targets.length === 1" class="py-1">
                          <span class="rounded-full bg-black text-white px-2 py-1 text-sm shadow-lg"
                            >{{ targets.length | number }} Available Opportunity</span
                          >
                        </div>
                      </div>
                      <div class="text-2xl font-bold pb-1">{{ targets[0].name }}</div>
                      <div *ngIf="targets[0].description">{{ targets[0].description }}</div>
                      <div class="divide-y divide-gray-600">
                        <div class="pt-2 pb-2">
                          <div *ngIf="targets[0].loadBonus" class="flex justify-between pb-2">
                            <div>Bonus</div>
                            <div
                              *ngIf="targets[0].loadBonus.type === 'cents'"
                              class="font-bold cursor-pointer"
                              [matTooltip]="
                                'Bonus added to loads dispatched before ' +
                                (targets[0].loadBonus.expiresAt | standardDate) +
                                ' for drivers who transfer to region'
                              "
                            >
                              {{ targets[0].loadBonus.quantity | currencyInPennies }} Per-Load Bonus
                            </div>
                            <div
                              *ngIf="targets[0].loadBonus.type === 'percent'"
                              class="font-bold cursor-pointer"
                              [matTooltip]="
                                'Bonus added to loads dispatched before ' +
                                (targets[0].loadBonus.expiresAt | standardDate) +
                                ' for drivers who transfer to region'
                              "
                            >
                              {{ targets[0].loadBonus.quantity | number }}% Per-Load Bonus
                            </div>
                          </div>
                          <div class="flex justify-between pb-1">
                            <div>Revenue</div>
                            <div class="font-bold">
                              {{ 'Est. ' + (targets[0].estimatedCentsPerShift | currencyInPennies) + ' Per Shift' }}
                            </div>
                          </div>
                          <button class="text-blue-500" (click)="showRevenueCalculation()">
                            How is this calculated?
                          </button>
                        </div>
                        <div class="pt-2 space-y-2">
                          <div class="flex justify-between">
                            <div>Project Start Date</div>
                            <div *ngIf="targets[0].startDate; else asap" class="font-bold">
                              {{
                                targets[0].startDate.month +
                                  '/' +
                                  targets[0].startDate.day +
                                  '/' +
                                  targets[0].startDate.year
                              }}
                            </div>
                            <ng-template #asap>
                              <label class="font-bold">ASAP</label>
                            </ng-template>
                          </div>
                          <div class="flex justify-between">
                            <div>Project Duration</div>
                            <div class="font-bold">{{ targets[0].durationDays | number }} Days</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="mb-1 md:mb-3 ml-1">
                        <b>Have questions?</b> Speak with a representative about this opportunity
                        <div class="flex items-center">
                          <img src="assets/images/representative-phone.png" class="w-2 h-2 mr-1" />
                          <a href="tel:+1-720-295-4969">1-720-295-4969</a>
                        </div>
                      </div>
                      <div class="w-full flex space-x-2">
                        <button
                          (click)="onClickNotInterested(targets[0].sandDemandSnapshotId)"
                          class="w-full p-2 bg-gray-600 text-white font-bold"
                        >
                          Skip
                        </button>
                        <button
                          (click)="onClickOpportunity(targets[0])"
                          class="w-full p-2 bg-blue-500 text-white font-bold"
                        >
                          View Details
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noInbox>
                  <div class="h-full flex flex-wrap content-end justify-center" *lohiRelationship="'carrier'">
                    <div class="flex flex-col items-center justify-center px-3">
                      <img src="./assets/images/fisherman.png" class="w-16 h-16" />
                      <div class="text-gray-600 font-bold mb-1 mt-2 text-center">
                        Congratulations! You have viewed all available opportunities.
                      </div>
                      <div class="text-gray-600 font-bold text-center">
                        Please check back later as demand changes frequently!
                      </div>
                    </div>
                    <div class="flex py-2 px-3 mt-5 mb-1 bg-blue-300 bg-opacity-25">
                      <div>
                        <div class="font-bold mb-1">Want more opportunities?</div>
                        <div class="mb-2">Get access to even more projects with "Super Drivers".</div>
                        <a class="rounded-full bg-blue-300 p-1" [routerLink]="['/superhighway']">Get Started</a>
                      </div>
                      <img src="assets/images/super-highway-logo.png" class="ml-1 w-12 h-12 opacity-25" />
                    </div>
                  </div>
                  <div class="h-full flex flex-wrap content-center justify-center" *lohiRelationship="'broker'">
                    <div class="flex flex-col items-center justify-center px-3">
                      <img src="./assets/images/fisherman.png" class="w-16 h-16" />
                      <div class="text-gray-600 font-bold mb-1 mt-2 text-center">
                        Congratulations! You have viewed all available opportunities.
                      </div>
                      <div class="text-gray-600 font-bold text-center">
                        Please check back later as demand changes frequently!
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </mat-tab>
            <mat-tab label="Accepted">
              <ng-container *ngIf="acceptedTargets$ | async as targets">
                <div
                  class="pl-3 p-2 cursor-pointer"
                  *ngFor="let target of targets; trackBy: 'sandDemandSnapshotId' | trackByKey"
                  (click)="onClickOpportunity(target)"
                >
                  <div class="font-bold">{{ target.name }}</div>
                  <div class="text-gray-900">Confirmed Drivers:</div>
                  <div *ngFor="let driver of target.acceptedDrivers; trackBy: 'driverId' | trackByKey">
                    <li class="text-sm text-gray-900">{{ driver.driverName }}</li>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
            <mat-tab label="Skipped">
              <ng-container *ngIf="dismissedTargets$ | async as targets">
                <div
                  class="pl-3 p-2 cursor-pointer"
                  *ngFor="let target of targets; trackBy: 'sandDemandSnapshotId' | trackByKey"
                  (click)="onClickOpportunity(target)"
                >
                  <div class="font-bold">{{ target.name }}</div>
                  <div class="flex justify-between">
                    <div>
                      <div *ngIf="target.startDate; else asapDuration" class="text-gray-900">
                        Start By:
                        {{
                          ' ' +
                            target.startDate.month +
                            '/' +
                            target.startDate.day +
                            '/' +
                            target.startDate.year +
                            '  |  Next ' +
                            target.durationDays +
                            ' days'
                        }}
                      </div>
                      <ng-template #asapDuration class="text-gray-900">
                        {{ 'ASAP' + '  |  Next ' + (target.durationDays | number) + ' days' }}
                      </ng-template>
                    </div>
                    <div class="text-gray-900 mr-2">
                      {{ ' ' + (target.estimatedCentsPerShift | currencyInPennies) + ' / Shift' }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </mat-tab>
          </mat-tab-group>
        </div>

        <div
          class="card-with-shadow bg-white flex flex-col justify-between p-3 h-75 overflow-y-scroll"
          *ngSwitchCase="'targetDetails'"
        >
          <div class="divide-y divide-gray-600 text-lg">
            <div class="flex flex-col space-y-2 pb-1">
              <div class="flex flex-row justify-between">
                <img
                  class="h-2 w-2 cursor-pointer"
                  src="assets/images/left-arrow.png"
                  (click)="targetSection = 'listOfTargets'"
                />
              </div>
              <div class="text-2xl font-bold pb-1 md:pt-2">{{ selectedTarget.name }}</div>
              <div *ngIf="selectedTarget.description" class="pb-1">{{ selectedTarget.description }}</div>
            </div>
            <div class="flex flex-col space-y-2 pt-2">
              <div class="font-bold">Project Scope & Requirements</div>
              <li>Project Duration: {{ selectedTarget.durationDays | number }} days</li>
              <li>Drivers Needed: {{ selectedTarget.driversDesired | number }}</li>
              <li>
                Experience Required:
                <ul *ngFor="let experience of selectedTarget.experienceNames; trackBy: 'experience' | trackByKey">
                  <li class="pl-4 pt-1">- {{ experience }}</li>
                </ul>
              </li>
              <!--            <li>-->
              <!--              Allowed Trailers:-->
              <!--              <ul *ngFor="let trailerType of selectedTarget.trailerTypeNames; trackBy: 'trailerType' | trackByKey">-->
              <!--                <li class="pl-4 pt-1">- {{ trailerType }}</li>-->
              <!--              </ul>-->
              <!--            </li>-->
            </div>
          </div>
          <div class="flex flex-col">
            <div *ngIf="selectedTarget.driversDesired === 0" class="text-red-500 text-sm mb-2">
              No more drivers are needed at this location
            </div>
            <div class="mb-1 md:mb-3 ml-1">
              <b>Have questions?</b> Speak with a representative about this opportunity
              <div class="flex items-center">
                <img src="assets/images/representative-phone.png" class="w-2 h-2 mr-1" />
                <a href="tel:+1-720-295-4969">1-720-295-4969</a>
              </div>
            </div>
            <button
              class="p-2 bg-blue-500 text-white font-bold"
              (click)="onClickSelectDriver()"
              [disabled]="!selectedTarget.drivers"
            >
              Select Drivers
            </button>
          </div>
        </div>

        <div
          class="card-with-shadow bg-white flex flex-col justify-between p-3 h-75 overflow-y-scroll"
          *ngSwitchCase="'selectDrivers'"
        >
          <div class="flex flex-col space-y-2 pb-3">
            <img
              class="h-2 w-2 cursor-pointer"
              src="assets/images/left-arrow.png"
              (click)="targetSection = 'targetDetails'"
            />
            <div class="text-2xl md:pt-2 font-bold">{{ selectedTarget.name }}</div>
            <div>
              Upon confirming the project, the selected drivers will be notified by text message to end their hitch and
              transfer regions.
            </div>
            <ng-container *ngIf="selectedTarget.drivers">
              <form [formGroup]="">
                <button class="text-blue-500 mb-1" (click)="showDriverSelection()">
                  How are these drivers selected?
                </button>
                <div *ngFor="let region of selectedTarget.regionDrivers; trackBy: 'driverId' | trackByKey" class="mb-2">
                  <div class="font-bold">
                    {{ region.regionName + ' - Select up to ' + region.maxDrivers }}
                  </div>
                  <div
                    *ngFor="let driver of region.drivers"
                    class="flex items-center mt-1 cursor-pointer"
                    [matTooltip]="tooltip(driver)"
                  >
                    <input
                      type="checkbox"
                      (change)="onCheckboxSelected(driver.driverId, driver.driverName, selectedTarget.driversDesired)"
                      class="cursor-pointer mr-2"
                    />
                    {{ driver.driverName + ' (' + (driver.milesFromOpportunity | number) + ' miles away)' }}
                  </div>
                </div>
              </form>
            </ng-container>
          </div>
          <div *ngIf="disableConfirmButton && checkboxDriverIds.size > 0" class="text-red-500 text-sm">
            Only {{ selectedTarget.driversDesired }} drivers are needed at this location.
          </div>
          <button
            class="p-2 bg-blue-500 text-white font-bold"
            [disabled]="disableConfirmButton"
            (click)="onClickConfirmProject()"
          >
            Confirm Project
          </button>
        </div>

        <div
          class="card-with-shadow bg-white flex flex-col justify-between p-3 h-75 overflow-y-scroll"
          *ngSwitchCase="'projectConfirmed'"
        >
          <div class="text-lg">
            <div class="divide-y divide-gray-600 pb-4">
              <div class="flex flex-col space-y-2 pb-3">
                <div class="text-2xl font-bold pb-2 pt-2">Project Confirmed</div>
                <div class="flex justify-between">
                  <div>Project</div>
                  <div class="font-bold">{{ selectedTarget.name }}</div>
                </div>
                <div class="flex justify-between">
                  <div>Start Date</div>
                  <div *ngIf="selectedTarget.startDate; else asap" class="font-bold">
                    {{
                      selectedTarget.startDate.month +
                        '/' +
                        selectedTarget.startDate.day +
                        '/' +
                        selectedTarget.startDate.year
                    }}
                  </div>
                  <ng-template #asap>
                    <label class="font-bold">ASAP</label>
                  </ng-template>
                </div>
                <div class="flex justify-between">
                  <div>Revenue</div>
                  <div class="font-bold">
                    {{ 'Est. ' + (selectedTarget.estimatedCentsPerShift | currencyInPennies) + ' Per Shift' }}
                  </div>
                </div>
              </div>
              <div class="flex flex-col pt-3">
                <div *ngFor="let driverName of checkboxDriverNames; trackBy: 'driverName' | trackByKey">
                  <li>{{ driverName }}</li>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="bg-green-lime bg-opacity-25 p-2 mb-3">
              <div class="text-green-500 font-bold pb-1">
                Note: Please make sure to contact the above drivers about this project.
              </div>
              <div>
                As the owner, it is your responsibility to confirm these drivers are in the area and ready to start work
                on time.
              </div>
            </div>
            <div class="flex flex-col">
              <div class="mb-1 md:mb-3 ml-1">
                <b>Have questions?</b> Speak with a representative about this opportunity
                <div class="flex items-center">
                  <img src="assets/images/representative-phone.png" class="w-2 h-2 mr-1" />
                  <a href="tel:+1-720-295-4969">1-720-295-4969</a>
                </div>
              </div>
              <button class="w-full p-2 bg-blue-500 text-white font-bold" (click)="onClickAvailable()">
                Back to Available Opportunities
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *lohiFeatureFlag="'maxPayLoopKPIs'">
    <div *lohiFeatureFlag="'maxPayLoop'" class="p-1 lg:px-3">
      <div class="font-semibold text-lg pb-1" *ngIf="tourRev$ | async as stats">Long Haul</div>
      <div class="flex flex-col flex-wrap lg:flex-row gap-x-2 gap-y-2" *ngIf="tourRev$ | async as stats">
        <div class="flex-1">
          <div class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1">
            <div class="flex flex-col p-2">
              <div class="flex flex-row mb-1 items">
                <span class="text-lg text-gray-900 font-semibold mr-1">Revenue</span>
                <span class="text-sm text-gray-500" matTooltip="Loads billed before Friday at 11:59pm Central Time."
                  >(Current Week) <mat-icon inline>info</mat-icon></span
                >
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.revenueCents | currencyInPennies: 'USD':'symbol':'1.0-0'
              }}</span>
              <div
                class="flex flex-col divide-y divide-gray-500 mt-2 border-t border-gray-500"
                *ngIf="stats.pastWeekRevenueCents !== 0"
              >
                <div class="flex flex-row items-center justify-between py-1">
                  <div>Past Week</div>
                  <div class="font-semibold">
                    {{ stats.pastWeekRevenueCents | currencyInPennies: 'USD':'symbol':'1.0-0' }}
                  </div>
                </div>
                <div class="flex flex-row items-center justify-between py-1" *ngIf="stats.percentChange !== 0">
                  <div>Change From Prior Week</div>
                  <div class="font-semibold">{{ stats.percentChange | number }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1">
            <div class="flex flex-col p-2">
              <div class="flex flex-row mb-1 items">
                <span class="text-lg text-gray-900 font-semibold mr-1">$ / Mile</span>
                <span class="text-sm text-gray-500">(Current Week)</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.thisWeekDpmCents | currencyInPennies
              }}</span>
              <div
                class="flex flex-col divide-y divide-gray-500 mt-2 border-t border-gray-500"
                *ngIf="stats.pastWeekDPMCents !== 0"
              >
                <div class="flex flex-row items-center justify-between py-1">
                  <div>Past Week</div>
                  <div class="font-semibold">
                    {{ stats.pastWeekDPMCents | currencyInPennies: 'USD':'symbol':'1.0-0' }}
                  </div>
                </div>
                <div class="flex flex-row items-center justify-between py-1" *ngIf="stats.dpmPercentChange !== 0">
                  <div>Change From Prior Week</div>
                  <div class="font-semibold">{{ stats.dpmPercentChange | number }}%</div>
                </div>
              </div>
            </div>
            <!--<div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Long Haul KPIs</span>
            </div>-->
          </div>
        </div>
        <div class="flex-1">
          <div class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600">
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Revenue By Asset Type</span>
                <span class="text-sm text-gray-500">(Past 30 Days)</span>
              </div>
              <lohi-tours-asset-chart [data]="(tourRev$ | async)?.assetRevenue || []"></lohi-tours-asset-chart>
            </div>
            <!--<div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Long Haul KPIs</span>
            </div>-->
          </div>
        </div>
        <div class="flex-1">
          <div class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600">
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Export</span>
              </div>
              <mat-form-field class="w-full">
                <mat-label>Loads Booked Between</mat-label>
                <mat-date-range-input [formGroup]="exportGroup" [rangePicker]="picker">
                  <input matStartDate formControlName="start" placeholder="Start date" />
                  <input matEndDate formControlName="end" placeholder="End date" />
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              <button (click)="downloadExport()" mat-flat-button>Download Export</button>
            </div>
            <!--<div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Long Haul KPIs</span>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *lohiIsNotOnlyFiveFTourOwner>
    <div *lohiFeatureFlag="'preferredPartnerCarrierUI'" class="p-1 lg:px-3 pb-3">
      <div class="font-semibold text-lg pb-1">Preferred Partner Program</div>
      <lohi-ppp-summary-card></lohi-ppp-summary-card>
    </div>
  </ng-container>

  <ng-container *lohiIsNotOnlyFiveFTourOwner>
    <div *lohiFeatureFlag="'migrationMapStats'" class="p-1 lg:px-3 pb-3">
      <div class="font-semibold text-lg pb-1">Short Haul</div>
      <div class="flex flex-col lg:flex-row gap-x-2 gap-y-2">
        <ng-container *ngIf="stats$ | async as stats">
          <a
            class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
            [routerLink]="['../../kpis']"
          >
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Revenue</span>
                <span class="text-sm text-gray-500">(Past 30 days)</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.pastRevenue | currencyInPennies: 'USD':'symbol':'1.0-0'
              }}</span>
            </div>
            <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Short Haul KPIs</span>
            </div>
          </a>
          <ng-container *lohiIsNotOnlyFiveFTourOwner>
            <a
              class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
              [routerLink]="['../calendar']"
            >
              <div class="flex flex-col p-2 border-b border-gray-300">
                <div class="flex flex-row mb-1">
                  <span class="text-lg text-gray-900 font-semibold mr-1">No Shows Yesterday</span>
                </div>
                <span class="text-gray-900 text-5xl font-semibold leading-none">
                  {{ noShowYesterday | number }}
                </span>
              </div>
              <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
                <span class="material-icons text-base mr-1">arrow_forward</span>
                <span>View Driver Calendar</span>
              </div>
            </a>
          </ng-container>

          <a
            class="card-with-shadow flex flex-col bg-white rounded border-t-4 border-gray-600 flex-1 cursor-pointer"
            [routerLink]="['../../loads/list/completed']"
          >
            <div class="flex flex-col p-2 border-b border-gray-300">
              <div class="flex flex-row mb-1">
                <span class="text-lg text-gray-900 font-semibold mr-1">Loads Needing Audit</span>
              </div>
              <span class="text-gray-900 text-5xl font-semibold leading-none">{{
                stats.loadsNeedAuditing | number
              }}</span>
            </div>
            <div class="flex flex-row text-sm text-gray-700 px-2 py-2 items-center">
              <span class="material-icons text-base mr-1">arrow_forward</span>
              <span>View Completed Loads</span>
            </div>
          </a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #originalDashboard>
  <lohi-owner-dashboard-main></lohi-owner-dashboard-main>
</ng-template>
<ng-template #revenueCalculation>
  <div class="grid justify-items-end">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col items-center">
    <img src="assets/images/revenue-calculation.png" class="w-16 h-12 pb-1" />
  </div>
  <div>
    <div class="font-bold py-1">How is revenue calculated?</div>
    <div class="pb-1">
      Estimated Revenue is calculated by taking the average revenue per shift in the new region over the previous 14
      days. Additional bonuses or deadhead pay are not taken into account.
    </div>
  </div>
</ng-template>
<ng-template #driverSelection>
  <div class="grid justify-items-end">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="flex flex-col items-center">
    <img src="assets/images/revenue-calculation.png" class="w-16 h-12 pb-1" />
  </div>
  <div>
    <div class="font-bold py-1">How are these drivers selected?</div>
    <div class="pb-1">
      Drivers are selected based on whether they are projected to make more money in the new region than their current
      region. We take into account the following factors:
    </div>
    <li>The time it takes to travel</li>
    <li>The cost of diesel to travel from one region to another</li>
    <li>The estimated revenue the driver will generate in the new region</li>
    <li>The past two weeks of revenue in their current region</li>
    <div class="pt-1">
      If we calculate that the driver will make more money in the new region, they will appear in this list of drivers.
      Drivers who would generate more revenue in their current region will not appear in this list.
    </div>
  </div>
</ng-template>
